import { render, staticRenderFns } from "./PosIdFlags.vue?vue&type=template&id=4f0c3560&scoped=true&"
import script from "./PosIdFlags.vue?vue&type=script&lang=js&"
export * from "./PosIdFlags.vue?vue&type=script&lang=js&"
import style0 from "./PosIdFlags.vue?vue&type=style&index=0&id=4f0c3560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c3560",
  null
  
)

export default component.exports